'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = schema;

var _docPropType = require('./docPropType');

var _docPropType2 = _interopRequireDefault(_docPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function schema(component) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!component) {
    throw new Error('schema: component is required');
  }
  if (!metadata.description) {
    throw new Error('schema: description is required');
  }

  var reactDesc = _extends({}, metadata);
  delete reactDesc.props;
  var defaultProps = void 0;
  var propTypes = void 0;

  if (metadata.props) {
    Object.keys(metadata.props).forEach(function (propName) {
      var prop = metadata.props[propName];
      // if it is an array it means that it is a react schema instance
      if (Array.isArray(prop)) {
        var validate = prop[0];
        var description = prop[1];
        var options = prop[2];

        if (options && options.defaultProp) {
          if (!defaultProps) {
            defaultProps = {};
          }
          defaultProps[propName] = options.defaultProp;
          delete options.defaultProp;
        }

        if (!propTypes) {
          propTypes = {};
        }
        propTypes[propName] = (0, _docPropType2.default)(validate, description, options);
      } else {
        propTypes[propName] = prop;
      }
    });
  }

  /* eslint-disable no-param-reassign */
  component.$$reactDesc = reactDesc;
  if (propTypes) {
    component.propTypes = propTypes;
  }
  if (defaultProps) {
    component.defaultProps = defaultProps;
  }
  /* eslint-enable no-param-reassign */
}


//////////////////
// WEBPACK FOOTER
// ./~/react-desc/lib/schema.js
// module id = 544
// module chunks = 0